<template>
  <h1
    :style="{ fontSize: calculateFontSize,'text-align': $route.path === '/workspace' ? 'center' : '' }"
    style="margin-top: 30px; padding: 0 15px;"
  >
    {{ titleToShow }}
  </h1>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  props: {
    fontSize: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    titleToShow () {
      if (this.$route.path === '/workspace' || this.$route.path === '/snapshots' || this.$route.path === '/workspaces') {
        return this.$t('botPageTitle.administrationModule')
      } else {
        return this.$t(this.$route.name)
      }
      // if (this.$route.path === '/lista-assistentes' && typeof this.assistantData.data.name === typeof undefined) {
      //   return 'Selecione um Assistente Cognitivo'
      // } else if (typeof this.assistantData.data.name !== typeof undefined) {
      //   return this.assistantData.data.name
      // } else {
      //   return ''
      // }
    },
    calculateFontSize () {
      if (this.fontSize !== '') {
        return `${this.fontSize}px`
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return '25px'
      } else {
        return ''
      }
    }
  },
  mounted () {
    // console.log(this.$route.path === '/lista-assistentes')
  }
}
</script>

<style>

</style>
